// extracted by mini-css-extract-plugin
export default {"uploaderWrap":"UploadImage_uploaderWrap__zO8rM","label":"UploadImage_label__1i00E","icon":"UploadImage_icon__MRsAN","withImage":"UploadImage_withImage__vXwxl"};